import Axios from "axios";
import auth from "./authService";
import appSettings from "../services/appSettingsManager";
import { lookup } from "@/helpers.js";

import Qs from "qs";
import conf from "../app.config";
import router from "../router";

import NProgress from "nprogress";
NProgress.configure({ showSpinner: false });

// import store from "../store";

/*********** BEGIN XML PARSE INFO ***********/
import parser from "fast-xml-parser";
import he from "he";

const options = {
  attributeNamePrefix: "@_",
  attrNodeName: "attr", //default is 'false'
  textNodeName: "#text",
  ignoreAttributes: true,
  ignoreNameSpace: false,
  allowBooleanAttributes: false,
  parseNodeValue: true,
  parseAttributeValue: false,
  trimValues: true,
  cdataTagName: "__cdata", //default is 'false'
  cdataPositionChar: "\\c",
  parseTrueNumberOnly: false,
  arrayMode: false, //"strict"
  attrValueProcessor: (val, attrName) => he.decode(val, { isAttributeValue: true }), //default is a=>a
  tagValueProcessor: (val, tagName) => he.decode(val), //default is a=>a
  stopNodes: ["parse-me-as-string"],
};
/*********** XML XML PARSE INFO ***********/

const axiosInstance = Axios.create({
  timeout: 120000,
  // httpsAgent: new https.Agent({
  //   rejectUnauthorized: false
  // }),

  //NOTE: SETTING BASEURL IN "INTERCEPTOR" BECAUSE IT CAN CHANGE AND IT DOESN'T RE-UPDATE WITHOUT AN APP-RESTART/REFRESH OTHERWISE.
  // baseURL: appSettings
  //   .generateBaseURLFromSettings()
  //   .replace(/([^:]\/)\/+/g, "$1"),
  headers: {
    // crossDomain: true,
    Accept: "application/json, text/plain, */*",

    "Content-Type": "application/json; charset=utf-8",
  },
  paramsSerializer: (params) => {
    return Qs.stringify(params, { encodeValuesOnly: true });
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    NProgress.start();
    config.baseURL = appSettings.generateBaseURLFromSettings().replace(/([^:]\/)\/+/g, "$1");
    if (auth.isAuthenticated()) {
      config.headers.Authorization = auth.getBasicAuthFullString();
      //FIXME: ADD CUSTOM HEADERS FOR "SECURITY" (DON'T FORGET TO UPDATE NGINX)
      // config.headers.MobileAPIRequest = 1;
    }
    return config;
  },
  (error) => {
    NProgress.done();
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    NProgress.done();
    response.soapFullResponseToJson = null;
    response.soapResultSection = null;
    try {
      if (parser.validate(response.data) === true) {
        //NOTE: USING fast-xml-parser TO JSONify THE RESPONSE OBJECT
        response.soapFullResponseToJson = parser.parse(response.data, options);
        response.soapResultSection = lookup(response.soapFullResponseToJson, "result");
      }
    } catch (error) {
      console.log("NO PARSABLE SOAP RESPONSE");
    }
    return response;
  },
  (error) => {
    NProgress.done();
    //SOME UNKNOWN NETWORK ERROR
    if (!error.response) {
      auth.destroyToken();
      router.push({ name: "Login" });
    }

    //IF THERE IS A DEEPER RESPONSE OBJECT
    if (error.response) {
      //IF THERE IS A RESPONSE
      if ([401, 502].indexOf(error.response.status) > -1) {
        if (/\/(login|signin|register|signup)$/.test(window.location.href)) {
          return false;
        } //IF WE'RE ALREADY AT THE LOGIN SCREEN THEN DO NOTHING

        auth.destroyToken();
        // window.location.assign('/login') //SHOULD PROBABLY WORK WITH THE 'ROUTER', BUT MEH FOR NOW
        //NEED TO SEND THEM BACK TO LOGIN, BUT I'M NOT SURE HOW TO ACCESS ROUTER FROM HERE . . . MAYBE JUST A VANILLA 'window' REDIRECT?
        // store.commit("projects/RESET_ALL_PROJECT_INFO");
        router.push({ name: "Login" });
      }

      if ([403].indexOf(error.response.status) > -1) {
        router.push({ name: "Login" });
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
